
import { gql } from "@apollo/client";



export const postClaimMessage = gql`
  mutation PostClaimMessage(
    $claimId: ID!
    $reinsurerId: ID!
    $body: String!
    $isInternal: Boolean
    $subject: String
  ) {
    postClaimMessage(
      claim_id: $claimId
      reinsurer_id: $reinsurerId
      body: $body
      is_internal: $isInternal
      subject: $subject
    ) {
      status
      message
      data {
        thread_id
        message {
          id
          sender_id
          sender_name
          body
          is_internal
          is_read
          created_at
        }
      }
    }
  }
`;

export const markMessageRead = gql`
  mutation MarkMessageRead($messageId: ID!) {
    markMessageRead(message_id: $messageId) {
      status
      message
      data {
        message_id
      }
    }
  }
`;